import { Injectable } from '@angular/core';
import { select, State, Store } from '@ngrx/store';
import { Observable } from 'rxjs/index';
import { NotificationState } from './notification.reducer';

const unreadMessagesSelector = (state: NotificationState) => (state as any).notification.unreadMessages;

@Injectable({
    providedIn: 'root' // No need to provide in AppModule, and now tree shakable
})
export class NotificationSelectors {

    constructor(private store: Store<any>) {
    }

    selectUnreadMessages(): Observable<any> {
        return this.store
            .pipe(select(unreadMessagesSelector));
    }
}
